import styled from 'styled-components';
import theme from 'common/theme';

const pad = `.5em`
const resFontSize = 'clamp(13.5px, 1.2vw, 16px)'

export const ToggleSectionContainer = styled.details`
  color: ${theme.colors.gray800};
  border-top: solid 1px ${theme.colors.border.lightest};
  

  &.is-disabled {
    pointer-events: none;
  }
  &:first { 
    border-top: solid 1px transparent;  
  }

  .full {
    width: 100%;
    flex-grow: 1;
  }

  summary, .toggle-summary {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: ${pad} 0;
    gap: ${pad};
    
    h3, .toggle-title {
      flex-grow: 1;
      margin: 0;
      padding: 0;
      font-weight: 500;
    }
  }

  section,
  .toggle-section {
    padding: ${pad} 0;
    margin-bottom: 1.875em;
  }

  [data-id='toggle-icon'] {
    transition: transform 0.1s;
    transform: rotate(90deg);
    height: .7em;
    path {
      stroke: ${theme.colors.jbtBlue};
      stroke-width: 2;
    }
  }

  &:not([open]) {
    [data-id='toggle-icon'] {
      transform: rotate(0deg);
    }
  }

  &.chart-wrapper {
     font-size: ${resFontSize};
   
    border-radius: ${theme.radius.base};
    padding: 0;
    h2 {
      font-weight: 500;
      font-size: 1em;
      margin: 0;
      padding: 0;
    }
  
    summary {
      text-transform: capitalize;
      padding: 1em;
      border-radius: ${theme.radius.base};
      overflow: hidden;
      background-color: ${theme.colors.gray200};      
    }

    &:hover {
      border-color: ${theme.colors.gray400};
       transition: border-color .3s; 
    }

    &:is([open]) {

      transition: background-color .3s, border-color .3s; 
      border-color: ${theme.colors.gray400};

      summary {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        background-color: white;
      }
      
      section {
        padding: 1em 4em 5em 5em;
      }
    }
  }
  
`